.overseasNote {
  font-size: var(--font-size-xs);
}
